import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const PrivateRoute = () => {
  const { authToken } = useAuth()
  const token = sessionStorage.getItem('authToken')

  if (!authToken && !token) {
    return <Navigate to="/" replace={true} />
  }

  return <Outlet />
}

export default PrivateRoute
